var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.966797 9.08332V0.916656H4.18971C4.82166 0.916656 5.40499 1.1111 5.93971 1.49999C6.47444 1.88888 6.7418 2.42846 6.7418 3.11874C6.7418 3.61457 6.62999 3.99617 6.40638 4.26353C6.18277 4.53089 5.97374 4.72291 5.7793 4.83957C6.02235 4.94652 6.29214 5.14582 6.58867 5.43749C6.8852 5.72916 7.03346 6.16666 7.03346 6.74999C7.03346 7.61527 6.71749 8.22048 6.08555 8.56562C5.4536 8.91075 4.86055 9.08332 4.30638 9.08332H0.966797ZM2.73138 7.44999H4.24805C4.71471 7.44999 4.99909 7.33089 5.10117 7.0927C5.20326 6.8545 5.2543 6.68193 5.2543 6.57499C5.2543 6.46805 5.20326 6.29548 5.10117 6.05728C4.99909 5.81909 4.70013 5.69999 4.2043 5.69999H2.73138V7.44999ZM2.73138 4.12499H4.08763C4.40846 4.12499 4.6418 4.04235 4.78763 3.87707C4.93346 3.7118 5.00638 3.52707 5.00638 3.32291C5.00638 3.08957 4.92374 2.89999 4.75846 2.75416C4.59319 2.60832 4.3793 2.53541 4.1168 2.53541H2.73138V4.12499Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatBold);
export default __webpack_public_path__ + "static/media/format_bold.99e9f4c0.svg";
export { ForwardRef as ReactComponent };